import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCarCrash,
  faExclamationTriangle,
  faMap,
  faMapMarkedAlt,
  faRandom,
  faSortDown,
  faSortUp,
  faTimes,
  faTruckLoading,
  faWater,
} from '@fortawesome/free-solid-svg-icons';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons/faBirthdayCake';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons/faMicrochip';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSearchMinus } from '@fortawesome/free-solid-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons/faStopwatch';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons/faTruckMoving';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';

export const loadIcons = () => {
  library.add(
    faAngleLeft,
    faArrowLeft,
    faArrowRight,
    faAsterisk,
    faBan,
    faBars,
    faBell,
    faBirthdayCake,
    faBook,
    faBuilding,
    faCalendarAlt,
    faCaretRight,
    faCarCrash,
    faChartBar,
    faChartLine,
    faCircle,
    faClock,
    faCloud,
    faCog,
    faCogs,
    faDatabase,
    faExclamationTriangle,
    faEye,
    faFilePdf,
    faFileSignature,
    faFlag,
    faHeart,
    faHome,
    faImage,
    faList,
    faLock,
    faMap,
    faMapMarkedAlt,
    faMapMarkerAlt,
    faMicrochip,
    faPencilAlt,
    faPlus,
    faRoad,
    faRandom,
    faSave,
    faSearch,
    faSearchMinus,
    faSearchPlus,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faStopwatch,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimes,
    faTimesCircle,
    faTrash,
    faTruckMoving,
    faTruckLoading,
    faUser,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWrench,
    faWater
  );
};
